const page_schema = {
	"tiers": [
		{
			"name": "Applications",
			"type": "checkbox",
			"id": "applications_dropdown",
			"class_name": "tags",
			"child_name": "application",
			"options": [
				{
					"name": "Bacteria",
					"id": "bacteria"
				},
				{
					"name": "Fungi",
					"id": "fungi"
				},
				{
					"name": "Archaea",
					"id": "archaea"
				},
				{
					"name": "Feces",
					"id": "feces"
				},
				{
					"name": "Soil",
					"id": "soil"
				},
				{
					"name": "Saliva",
					"id": "saliva"
				},
				{
					"name": "Skin",
					"id": "skin"
				},
				{
					"name": "Vaginal",
					"id": "vaginal"
				},
				{
					"name": "Tissue",
					"id": "tissue"
				},
				{
					"name": "Water",
					"id": "water"
				},
				{
					"name": "Plants",
					"id": "plants"
				},
				{
					"name": "Insects",
					"id": "insects"
				},
				{
					"name": "Urine",
					"id": "urine"
				},
				{
					"name": "Blood",
					"id": "blood"
				},
			]
		},
		{
			"name": "Features",
			"type": "checkbox",
			"id": "features",
			"class_name": "tags",
			"child_name": "feature",
			"options": [
				{
					"name": "Low Input",
					"id": "low-input"
				},
				{
					"name": "Long Read",
					"id": "long-read"
				},
				{
					"name": "Extraction Control",
					"id": "extraction-control"
				},
				{
					"name": "Library Prep Control",
					"id": "library-prep-control"
				},
				{
					"name": "Absolute Quantification",
					"id": "absolute-quantification"
				},
				{
					"name": "Limit of Detection",
					"id": "limit-of-detection"
				},
			]
		},
		{
			"name": "Formats",
			"type": "checkbox",
			"id": "formats",
			"class_name": "tags",
			"child_name": "format",
			"options": [
				{
					"name": "Intact Cells",
					"id": "intact-cells"
				},
				{
					"name": "DNA",
					"id": "dna"
				},
				{
					"name": "Native Diversity",
					"id": "native-diversity"
				},
				{
					"name": "Mock Community",
					"id": "mock-community"
				},
				{
					"name": "Spike-in Control",
					"id": "spike-in-control"
				},
			]
		},
	],
	"filters": [],
	"products": {
		"ZymoBIOMICS Microbial Community Standard": {
			"title": "ZymoBIOMICS Microbial Community Standard",
			"catalogNumbers": "D6300",
			"description": "Microbial composition profiling techniques powered by Next-Generation sequencing are becoming routine in microbiomics and metagenomics studies. However, these analytical techniques can suffer from significant bias from collection to analysis. The ZymoBIOMICS Microbial Community Standard is designed to assess bias and errors in the extraction methods of a microbiomics workflow. The Microbial Community Standard mimics a mixed microbial community of well-defined composition, containing three easy-to-lyse Gram-negative bacteria, five tough-to-lyse Gram-positive bacteria, and two tough-to-lyse yeasts. Acting as a defined input from the beginning, the Microbial Community Standard can guide construction and optimization of entire workflows and can also be used as a routine quality control. Theoretical Composition Based on Genomic DNA: Listeria monocytogenes - 12%, Pseudomonas aeruginosa - 12%, Bacillus subtilis - 12%, Escherichia coli - 12%, Salmonella enterica - 12%, Lactobacillus fermentum - 12%, Enterococcus faecalis - 12%, Staphylococcus aureus - 12%, Saccharomyces cerevisiae - 2%, and Cryptococcus neoformans - 2%.",
			"handle": "/collections/zymobiomics-microbial-community-standards/products/zymobiomics-microbial-community-standard",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6300_ZymoBIOMICS-Microbial-Community-Standard.jpg?v=1628532362&width=600",
			"generalIndex": "998",
			"tags": [
				"bacteria",
				"fungi",
				"feces",
				"soil",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"blood",
				"long-read",
				"extraction-control",
				"intact-cells",
				"mock-community",
			],
			filters: []
		},
		"ZymoBIOMICS Microbial Community DNA Standard": {
			"title": "ZymoBIOMICS Microbial Community DNA Standard",
			"catalogNumbers": "D6305, D6306",
			"description": "One of the major challenges in the emerging field of microbiomics is the bias and errors introduced in the complex workflows. Besides nucleic acid purification, bias also arises from sequencing library preparation and subsequent processes. The ZymoBIOMICS Microbial Community DNA Standard is designed to assess bias, errors and other artifacts after the step of nucleic acid purification. This DNA standard is created by pooling DNA extracted from pure cultures. It has an accurately defined composition, negligible impurities (0.01%), and contains genomes of a wide range of GC content (15% - 85%). This DNA standard is designed to have the same microbial composition with the cellular version, the ZymoBIOMICS Microbial Community Standard, so that they can be more powerful when working in tandem. Theoretical Composition Based on Genomic DNA: Listeria monocytogenes - 12%, Pseudomonas aeruginosa - 12%, Bacillus subtilis - 12%, Escherichia coli - 12%, Salmonella enterica - 12%, Lactobacillus fermentum - 12%, Enterococcus faecalis - 12%, Staphylococcus aureus - 12%, Saccharomyces cerevisiae - 2%, and Cryptococcus neoformans - 2%.",
			"handle": "/collections/zymobiomics-microbial-community-standards/products/zymobiomics-microbial-community-dna-standard",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6305_ZymoBIOMICS-Microbial-Community-Standard.jpg?v=1628532363&width=600",
			"generalIndex": "998",
			"tags": [
				"bacteria",
				"fungi",
				"feces",
				"soil",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"blood",
				"library-prep-control",
				"dna",
				"mock-community",
			],
			filters: []
		},
		"ZymoBIOMICS Microbial Community Standard II (Log Distribution)": {
			"title": "ZymoBIOMICS Microbial Community Standard II (Log Distribution)",
			"catalogNumbers": "D6310",
			"description": "ZymoBIOMICS Microbial Community Standard II (Log Distribution) is a mock microbial community consisting of eight bacterial and two fungal strains. This microbial standard can be used to assess the performance of microbiomics workflows and can also be used as a positive control for routine sequencing. Cells of the ten microbes were mixed in a log-distributed abundance, which allows the user to easily assess the detection limit of their microbiomics workflow. 75 µl of the standard contains about ~100 cells of Staphylococcus aureus, the organism of lowest abundance. If needed, the standard can be spiked into a sample matrix (e.g. soil and blood) to mimic real samples of interest. Theoretical Composition Based on Genomic DNA: Listeria monocytogenes - 89.1%, Pseudomonas aeruginosa - 8.9%, Bacillus subtilis - 0.89%, Saccharomyces cerevisiae - 0.89%, Escherichia coli - 0.089%, Salmonella enterica - 0.089%, Lactobacillus fermentum - 0.0089%, Enterococcus faecalis - 0.00089%, Cryptococcus neoformans - 0.00089%, and Staphylococcus aureus - 0.000089%.",
			"handle": "/collections/zymobiomics-microbial-community-standards/products/zymobiomics-microbial-community-standard-ii-log-distribution",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6310_ZymoBIOMICS-Microbial-Community-Standard-II-Log-Distribution_750-ul.jpg?v=1628532379&width=600",
			"generalIndex": "998",
			"tags": [
				"bacteria",
				"fungi",
				"feces",
				"soil",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"blood",
				"low-input",
				"long-read",
				"extraction-control",
				"limit-of-detection",
				"intact-cells",
				"mock-community",
			],
			filters: []
		},
		"ZymoBIOMICS Microbial Community DNA Standard II (Log Distribution)": {
			"title": "ZymoBIOMICS Microbial Community DNA Standard II (Log Distribution)",
			"catalogNumbers": "D6311",
			"description": "ZymoBIOMICS Microbial Community DNA Standard II (Log Distribution) is a mixture of genomic DNA of eight bacterial and two fungal strains. The microbial standard is accurately characterized and contains negligible impurity (< 0.01%). It was constructed by pooling DNA extracted from pure cultures of the ten microbial strains. The DNA from each pure culture was quantified before pooling. After mixing, the microbial composition was confirmed using NGS-based sequencing. This microbial standard can be used to assess the performance of microbiomics workflows and can also be used as a positive control for the routine QC purpose. Theoretical Composition Based on Genomic DNA: Listeria monocytogenes - 89.1%, Pseudomonas aeruginosa - 8.9%, Bacillus subtilis - 0.89%, Saccharomyces cerevisiae - 0.89%, Escherichia coli - 0.089%, Salmonella enterica - 0.089%, Lactobacillus fermentum - 0.0089%, Enterococcus faecalis - 0.00089%, Cryptococcus neoformans - 0.00089%, and Staphylococcus aureus - 0.000089%.",
			"handle": "/collections/zymobiomics-microbial-community-standards/products/zymobiomics-microbial-community-dna-standard-ii-log-distribution",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6311_ZymoBIOMICS-Microbial-Community-Standard-II-Log-Distribution_20-ul.jpg?v=1628532418&width=600",
			"generalIndex": "998",
			"tags": [
				"bacteria",
				"fungi",
				"feces",
				"soil",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"blood",
				"low-input",
				"library-prep-control",
				"limit-of-detection",
				"dna",
				"mock-community",
			],
			filters: []
		},
		"ZymoBIOMICS Spike-in Control I (High Microbial Load)": {
			"title": "ZymoBIOMICS Spike-in Control I (High Microbial Load)",
			"catalogNumbers": "D6320, D6320-10",
			"description": "ZymoBIOMICS™ Spike-in Control I (High Microbial Load) consists of equal cell numbers of two bacteria strains, Imtechella halotolerans and Allobacillus halotolerans. When spiked into an unknown sample, this product will serve as an in situ positive control for DNA-sequencing-based (e.g. NGS-based) microbiome measurements. These two bacteria, Imtechella halotolerans (Gram-negative) and Allobacillus halotolerans (Gram-positive) represent different cell recalcitrance and can expose potential bias during DNA extraction. Moreover, with accurately quantified cell numbers, this standard enables absolute cell number quantification in microbiome measurements.",
			"handle": "/collections/zymobiomics-microbial-community-standards/products/zymobiomics-spike-in-control-i-high-microbial-load",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6320.png?v=1628532418&width=600",
			"generalIndex": "998",
			"tags": [
				"bacteria",
				"feces",
				"soil",
				"long-read",
				"absolute-quantification",
				"intact-cells",
				"spike-in-control",
			],
			filters: []
		},
		"ZymoBIOMICS Spike-in Control II (Low Microbial Load)": {
			"title": "ZymoBIOMICS Spike-in Control II (Low Microbial Load)",
			"catalogNumbers": "D6321, D6321-10",
			"description": "ZymoBIOMICS Spike-in Control II (Low Microbial Load) consists of three bacteria strains, Truepera radiovictrix, Imtechella halotolerans and Allobacillus halotolerans. When spiked into a microbial sample, this product will serve as an in situ positive control for DNA-sequencing-based microbiome measurements. Of the three chosen bacteria, Imtechella halotolerans is Gram-negative and Allobacillus halotolerans is Gram-positive. Truepera radiovictrix is resistant to lysozyme lysis and has very high GC content. They represent different challenges in NGS-based analysis. Moreover, with accurately quantified cell number and a log abundance distribution, this standard enables absolute cell number quantification in cases such as pathogen load detection.",
			"handle": "/collections/zymobiomics-microbial-community-standards/products/zymobiomics-spike-in-control-ii-low-microbial-load",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6321-zymobiomics_spike-in_control_ii.png?v=1628532418&width=600",
			"generalIndex": "998",
			"tags": [
				"bacteria",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"blood",
				"low-input",
				"long-read",
				"absolute-quantification",
				"limit-of-detection",
				"intact-cells",
				"spike-in-control",
			],
			filters: []
		},
		"ZymoBIOMICS HMW DNA Standard": {
			"title": "ZymoBIOMICS HMW DNA Standard",
			"catalogNumbers": "D6322",
			"description": "ZymoBIOMICS HMW DNA Standard is a mixture of high molecular weight genomic DNA isolated from pure cultures of seven bacterial and one fungal strains. It has an accurately defined composition, negligible impurities (<0.01%) and contains genomes of a wide range of GC content (15%-85%). This can be used to assess and benchmark the performance of long read/3rd generation sequencing for microbiomics and metagenomics analysis and can also be used as a routine quality control. Theoretical Composition Based on Genomic DNA: Pseudomonas aeruginosa - 14%, Escherichia coli - 14%, Salmonella enterica - 14%, Enterococcus faecalis - 14%, Staphylococcus aureus - 14%, Listeria monocytogenes - 14%, Bacillus subtilis - 14%, Saccharomyces cerevisiae - 2%.",
			"handle": "/collections/zymobiomics-microbial-community-standards/products/zymobiomics-hmw-dna-standard",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d6322-zymobiomics-hmw-dna-standard.png?v=1628532418&width=600",
			"generalIndex": "998",
			"tags": [
				"bacteria",
				"fungi",
				"feces",
				"soil",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"blood",
				"long-read",
				"library-prep-control",
				"dna",
				"mock-community",
			],
			filters: []
		},
		"ZymoBIOMICS Fecal Reference with TruMatrix™ Technology": {
			"title": "ZymoBIOMICS Fecal Reference with TruMatrix™ Technology",
			"catalogNumbers": "D6323",
			"description": "The ZymoBIOMICS Fecal Reference with TruMatrix™ Technology is a microbial reference material composed of stool from healthy donors for quality control, process validation, assay development, and proficiency testing. The fecal reference was homogenized in one large batch to produce consistency in every vial, eliminating typical lot-to-lot variability. With over 2 million preps available, this reference is intended to be used as a control for workflow performance, as well as comparing workflow consistency across replicates, studies, and laboratories. To facilitate methods comparison, a platform is in development to enable users to compare characterization data against applied methodology. For more information about the platform, please contact microbiomics@zymoresearch.com.",
			"handle": "/collections/zymobiomics-microbial-community-standards/products/zymobiomics-fecal-reference-with-trumatrix-technology",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6323_ZymoBIOMICS-Fecal-Reference-with-TruMatrix.jpg?v=1628532421&width=600",
			"generalIndex": "998",
			"tags": [
				"bacteria",
				"archaea",
				"feces",
				"long-read",
				"extraction-control",
				"intact-cells",
				"native-diversity",
			],
			filters: []
		},
		"ZymoBIOMICS Gut Microbiome Standard": {
			"title": "ZymoBIOMICS Gut Microbiome Standard",
			"catalogNumbers": "D6331",
			"description": "The ZymoBIOMICS Gut Microbiome Standard is an accurately quantified microbial community mimicking the human gut microbiome. The challenges it presents to microbiomics profiling allows researchers to validate protocols and fine-tune them for gut microbiome research and act as a positive control for sample processing.",
			"handle": "/collections/zymobiomics-microbial-community-standards/products/zymobiomics-gut-microbiome-standard",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d6331_zymobiomics_gut_microbiome_standard-750ul.png?v=1628532419&width=600",
			"generalIndex": "998",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"feces",
				"long-read",
				"extraction-control",
				"intact-cells",
				"mock-community",
			],
			filters: []
		},
		"ZymoBIOMICS Oral Microbiome Standard": {
			"title": "ZymoBIOMICS Oral Microbiome Standard",
			"catalogNumbers": "D6332",
			"description": "The ZymoBIOMICS Oral Microbiome Standard is an accurately quantified microbial community mimicking the human oral microbiome. The challenges it presents to microbiomics profiling allows researchers to validate protocols and fine-tune them for oral microbiome research and act as a positive control for sample processing.",
			"handle": "/products/zymobiomics-oral-microbiome-standard",
			"navigation_image": "https://www.zymoresearch.com/cdn/shop/files/d6332_product_image_1200x.jpg",
			"generalIndex": "998",
			"tags": [
				"bacteria",
				"saliva",
				"long-read",
				"extraction-control",
				"intact-cells",
				"mock-community",
			],
			filters: []
		},
		// "ZR BashingBead Lysis Tubes (2 mm)": {
		// 	"title": "ZR BashingBead Lysis Tubes (2 mm)",
		// 	"catalogNumbers": "S6003-50",
		// 	"description": "2mL tubes containing ultra-high density 2mm BashingBeads that are fracture resistant, chemically inert, and ideal for disrupting tough-to-lyse biological samples.",
		// 	"handle": "/collections/vector-and-environmental-collection/products/zr-bashing-bead-lysis-tubes",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2051_Direct-zol_RNA_MiniPrep_TRI_Reagent_with_BashingBead_Lysis_Tubes_172e2328-7c2f-4d06-9185-a82cf30de7c5.png?v=1628532422&width=600",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
		// "ZR BashingBead Lysis Tubes (0.1 & 0.5 mm)": {
		// 	"title": "ZR BashingBead Lysis Tubes (0.1 & 0.5 mm)",
		// 	"catalogNumbers": "S6012-50",
		// 	"description": "2mL tubes containing ultra-high density 0.1 and 0.5mm BashingBeads that are fracture resistant, chemically inert, and ideal for disrupting tough-to-lyse biological samples.",
		// 	"handle": "/collections/vector-and-environmental-collection/products/zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2051_Direct-zol_RNA_MiniPrep_TRI_Reagent_with_BashingBead_Lysis_Tubes_172e2328-7c2f-4d06-9185-a82cf30de7c5.png?v=1628532422&width=600",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
		// "ZR BashingBead Lysis Tubes (0.1 & 2.0 mm)": {
		// 	"title": "ZR BashingBead Lysis Tubes (0.1 & 2.0 mm)",
		// 	"catalogNumbers": "S6014-50",
		// 	"description": "2mL tubes containing ultra-high density 0.1 and 2.0mm BashingBeads that are fracture resistant, chemically inert, and ideal for disrupting tough-to-lyse biological samples.",
		// 	"handle": "/collections/vector-and-environmental-collection/products/zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2051_Direct-zol_RNA_MiniPrep_TRI_Reagent_with_BashingBead_Lysis_Tubes_172e2328-7c2f-4d06-9185-a82cf30de7c5.png?v=1628532422&width=600",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
		// "ZymoBIOMICS BashingBead Lysis Rack (0.5 mm & 0.1 mm)": {
		// 	"title": "ZymoBIOMICS BashingBead Lysis Rack (0.5 mm & 0.1 mm)",
		// 	"catalogNumbers": "S6002-96-7",
		// 	"description": "96-well lysis rack containing ultra-high density 0.1 and 0.5mm BashingBeads that are fracture resistant, chemically inert, and ideal for disrupting tough-to-lyse biological samples.",
		// 	"handle": "https://stage.zymoresearch.com/products/zymobiomics-bashingbead-lysis-rack",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/S6002-96-6_ZymoBIOMICSLysisRack.jpg?v=1706039540",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
		// "ZR-96 BashingBead Lysis Rack (Single barcoded Tubes)": {
		// 	"title": "ZR-96 BashingBead Lysis Rack (Single barcoded Tubes)",
		// 	"catalogNumbers": "S6002-96-4",
		// 	"description": "96 individually barcoded and screw capped lysis tubes in a single rack, containing ultra-high density 0.1 and 0.5mm BashingBeads that are fracture resistant, chemically inert, and ideal for disrupting tough-to-lyse biological samples.",
		// 	"handle": "/products/zr-96-bashingbead-lysis-rack-barcoded",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/s6002_96_lysis_rack.jpg?v=1672171183&width=600",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
		// "ZR-96 BashingBead Lysis Rack (Double barcoded Tubes)": {
		// 	"title": "ZR-96 BashingBead Lysis Rack (Double barcoded Tubes)",
		// 	"catalogNumbers": "S6002-96-5",
		// 	"description": "96 individually barcoded and screw capped lysis tubes in a single rack, containing ultra-high density 0.1 and 0.5mm BashingBeads that are fracture resistant, chemically inert, and ideal for disrupting tough-to-lyse biological samples.",
		// 	"handle": "/products/zr-96-bashingbead-lysis-rack-barcoded",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/s6002_96_lysis_rack.jpg?v=1672171183&width=600",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
		// "ZR BashingBead Lysis/Filtration Tubes": {
		// 	"title": "ZR BashingBead Lysis/Filtration Tubes",
		// 	"catalogNumbers": "S6010, S6011",
		// 	"description": "50 ml conical tube containing ultra-high density 0.5mm or 2.0mm BashingBeads that are fracture resistant, chemically inert, and ideal for disrupting tissues or microbes",
		// 	"handle": "/collections/vector-and-environmental-collection/products/zr-bashingbead-lysis-filtration-tubes",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S6010_ZR-BashingBead-Lysis-Filtration-Tube---50-mL.jpg?v=1628532394&width=600",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
		// "Bunny Wipe Fecal Sample Collector": {
		// 	"title": "Bunny Wipe Fecal Sample Collector",
		// 	"catalogNumbers": "R1133-1, R1133-10, R1138, R1101",
		// 	"description": "A fecal collection device that mimics toilet paper to provide comfortable, user-friendly collection. Samples are stabilized in pre-filled DNA/RNA Shield and ready for transport or storage.",
		// 	"handle": "/collections/fecal-collection/products/bunny-wipe-fecal-sample-collector",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/Wipe___Tube.jpg?v=1677089410&width=600",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
		// "Feces Catcher": {
		// 	"title": "Feces Catcher",
		// 	"catalogNumbers": "R1101-1-10",
		// 	"description": "A hygienic, flushable strip of fecal collection paper that fits onto any toilet seat for easy fecal collection",
		// 	"handle": "/collections/fecal-collection/products/feces-catcher",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1101-1-10_Feces-Catcher.jpg?v=1671135398&width=600",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
		// "ColOff (Stool Collection Device)": {
		// 	"title": "ColOff (Stool Collection Device)",
		// 	"catalogNumbers": "R1101-2-5",
		// 	"description": "A hygienic, disposable, easy-to-use stool collection facilitation device. It is a plastic sleeve that facilitates stool collection in a physiological position (sitting on the toilet seat).",
		// 	"handle": "/collections/fecal-collection/products/coloff-stool-collection-device",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1101-2-5_Coloff-Stool-Collection-Device.jpg?v=1671135003&width=600",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
		// "Sterile Collection Swab": {
		// 	"title": "Sterile Collection Swab",
		// 	"catalogNumbers": "C1052-50, C1053-50",
		// 	"description": "Individually packaged sterile fiber swabs for the collection of samples from the mouth, nose, and throat for research and pre-analytical diagnostic use. 20mm Break Point",
		// 	"handle": "/collections/swab-collection/products/sterile-collection-swab",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1052-50_Zymo_20Collection_20Swab_20-_2020_20mm_20Break_20Point.png?v=1628532409&width=600",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
		// "Urine Collection Cup": {
		// 	"title": "Urine Collection Cup",
		// 	"catalogNumbers": "D3062-1",
		// 	"description": "Small and easy-to-use plastic urine collection cups for research labs collecting urine specimens.",
		// 	"handle": "/collections/urine-collection/products/urine-collection-cup",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D3062-1_Urine-Collection-Cup_1ddcf228-f40e-461a-9319-238eab6650ae.jpg?v=1628532367&width=600",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
	}
}